import React, { Component } from 'react';

import './TravelDiaryToolItem.css'
export class TravelDiaryToolItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
        }

    }

    componentDidMount() {
    }

    render() {
        // 在 render 中將可以使用 this.context
        return (
            <div className={(this.props.checkedName == this.props.name) ? "travelDiaryToolItem active" : 'travelDiaryToolItem'} onClick={this.handleClick}>
                <span>{this.props.name}</span>
            </div>
        );
    }

    handleClick = () => {
        this.props.handleClick && this.props.handleClick(this.props.name);
    }
}